import { render } from "./Vue3Prism.vue?vue&type=template&id=bec0dec0&scoped=true"
import script from "./Vue3Prism.vue?vue&type=script&lang=js"
export * from "./Vue3Prism.vue?vue&type=script&lang=js"

import "./Vue3Prism.vue?vue&type=style&index=0&id=bec0dec0&lang=scss&scoped=true"

import exportComponent from "D:\\work\\vue-prism\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bec0dec0"]])

export default __exports__